function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "var(--primary-color, #000)",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.002
}, /*#__PURE__*/React.createElement("path", {
  d: "M19 7.836h16v41H19z"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 27,
  cy: 15.735,
  r: 4.543
}), /*#__PURE__*/React.createElement("circle", {
  cx: 27,
  cy: 28.535,
  r: 4.543
}), /*#__PURE__*/React.createElement("circle", {
  cx: 27,
  cy: 41.235,
  r: 4.543
}), /*#__PURE__*/React.createElement("path", {
  d: "M12 10h7v11h-3c0-5.077-3-3.385-4-11zM12 23h7v11h-3c0-5.077-3-3.385-4-11zM12 36h7v11h-3c0-5.077-3-3.385-4-11zM42 10h-7v11h3c0-5.077 3-3.385 4-11zM42 23h-7v11h3c0-5.077 3-3.385 4-11zM42 36h-7v11h3c0-5.077 3-3.385 4-11zM34.999 7.8H19.001c0-3.406 3.581-6.168 8-6.168 4.417 0 7.998 2.761 7.998 6.168zM24 49h6v6h-6z"
}));

var SvgTrafficlight = function SvgTrafficlight(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTrafficlight, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Traffic light.424b4137.svg";
export { ForwardRef as ReactComponent };